import type ReadingPaneInfoBarId from '../store/schema/ReadingPaneInfoBarId';

export default function initializeInfoBarIdsForItem(): ReadingPaneInfoBarId[] {
    return [
        'unsubscribeInfoBar',
        'safetyBar',
        'irmInfoBar',
        'infoImportance',
        'infoSensitivity',
        'infoFlagStatus',
        'infoMeetingDoNotForward',
        'infoLastUserAction',
    ];
}
